import { isDevelopment } from 'config/environment/environment.helper';
import config from 'config/environment';

export const getOrganizationAlias = (): string => {
  if (!isDevelopment()) {
    const location = document.location;
    if (location?.hostname) {
      const [alias = ''] = location.hostname.split('.');
      return alias;
    }
    return '';
  }

  return config.LOCALHOST_FLEET || 'jbhunt';
};
